  <mat-slide-toggle  class="user-login-menu-item" (click)="toggleEdit()" [checked]="editMode"><p class="paragraphCenterAlign"  [innerHTML]="resourcesService.getViewLabel('Global_Text_EditMode_Title')"></p></mat-slide-toggle>
  